export var normalizeRegionProvider = function (region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function () { return promisified_1; };
    }
    else {
        return region;
    }
};
export var normalizeCredentialsProvider = function (credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function () { return promisified_2; };
    }
    else {
        return credentials;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/signature-v4/dist-es/normalizeProvider.js
// module id = 354
// module chunks = 0